<p class="coupon-rule-history__intro">
  Alterações da mais recente para a mais antiga, no horário de Brasília. A regra
  vigente é a alteração mais recente até a data escolhida.
</p>

<form class="form-b4a" [formGroup]="filterForm" (ngSubmit)="search()">
  <span class="p-float-label">
    <p-calendar
      inputId="ruleHistoryFrom"
      formControlName="from"
      dateFormat="dd/mm/yy"
      [showIcon]="true"
      [showTime]="true"
      hourFormat="24"
      appendTo="body"
      [showButtonBar]="true"
    />
    <label for="ruleHistoryFrom">De</label>
  </span>
  <span class="p-float-label">
    <p-calendar
      inputId="ruleHistoryTo"
      formControlName="to"
      dateFormat="dd/mm/yy"
      [showIcon]="true"
      [showTime]="true"
      hourFormat="24"
      appendTo="body"
      [showButtonBar]="true"
    />
    <label for="ruleHistoryTo">Até</label>
  </span>
  <div class="buttons">
    <p-button
      type="button"
      label="Limpar"
      severity="secondary"
      [outlined]="true"
      (onClick)="clearFilters()"
    />
    <p-button type="submit" label="Filtrar" />
  </div>
</form>

<form class="form-b4a" [formGroup]="effectiveForm" (ngSubmit)="loadEffective()">
  <span class="p-float-label">
    <p-calendar
      inputId="ruleHistoryAt"
      formControlName="at"
      dateFormat="dd/mm/yy"
      [showIcon]="true"
      [showTime]="true"
      hourFormat="24"
      appendTo="body"
    />
    <label for="ruleHistoryAt">Regra vigente em</label>
  </span>
  <div class="buttons">
    <p-button type="submit" label="Ver regra vigente" />
  </div>
</form>

<p class="error coupon-rule-history__error" *ngIf="validationMessage">
  {{ validationMessage }}
</p>

<section *ngIf="effectiveLoaded" class="coupon-rule-history__effective">
  <h3>Regra vigente</h3>
  <p *ngIf="effectiveEmpty">{{ emptyHistoryMessage }}</p>
  <article *ngIf="effectiveEntry" class="coupon-rule-history__entry">
    <ng-container
      *ngTemplateOutlet="entryCard; context: { entry: effectiveEntry }"
    />
  </article>
</section>

<section>
  <h3>Histórico</h3>
  <p *ngIf="historyLoaded && historyEmpty">{{ emptyHistoryMessage }}</p>
  <article class="coupon-rule-history__entry" *ngFor="let entry of entries">
    <ng-container *ngTemplateOutlet="entryCard; context: { entry: entry }" />
  </article>
</section>

<ng-template #entryCard let-entry="entry">
  <header class="coupon-rule-history__meta">
    <span>{{ entry.whenLabel }}</span>
    <span>{{ entry.actionLabel }}</span>
    <span>{{ entry.actor }}</span>
  </header>
  <p><strong>Campos alterados:</strong> {{ entry.changedFieldsLabel }}</p>
  <div class="coupon-rule-history__diff" *ngIf="entry.hasDiff">
    <div class="coupon-rule-history__line" *ngFor="let line of entry.diffLines">
      <div class="coupon-rule-history__field">{{ line.fieldLabel }}</div>
      <div>
        <span>Antes</span>
        <pre>{{ line.beforeText }}</pre>
      </div>
      <div>
        <span>Depois</span>
        <pre>{{ line.afterText }}</pre>
      </div>
    </div>
  </div>
  <p *ngIf="!entry.hasDiff">Esta entrada não trouxe o antes e o depois.</p>
</ng-template>
